import React from "react";
import Card from "@mui/material/Card";
import { Box, Grid } from "@mui/material";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import ShareIcon from "@mui/icons-material/Share";
import RatingMUI from "./RatingMUI";
import CircularProgressMUI from "./CircularProgressMUI";

export default function CardMUI({ title, generalInfo, KPIinfo, logo }) {
  return (
    <Box
      sx={{
        width: "100%",
        height: "400px",
        color: "white",
      }}
    >
      <CardContent>
        <Box>
          {/* Title And Logo */}
          <Grid
            spacing={2}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 3,
              marginBottom: 2,
            }}
          >
            {/* Title */}
            <Grid item xs={6}>
              <Typography variant="h5" sx={{ color: "white" }}>
                {title}
              </Typography>
            </Grid>

            {/* Logo */}
            <Grid item xs={6}>
              <img
                src="/images/contoso-logo.png" // Replace with your logo URL
                alt="Logo"
                style={{ width: "50px", height: "50px" }}
              />
            </Grid>

            {/* Action */}
            <Grid item xs={6}>
              <IconButton aria-label="download">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="#D3F4FE"
                  class="bi bi-download button-child m-0"
                  viewBox="0 0 16 16"
                >
                  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                </svg>
              </IconButton>
              <IconButton aria-label="share" sx={{ color: "#D3F4FE" }}>
                <ShareIcon />
              </IconButton>
            </Grid>
          </Grid>

          {/* General Content */}
          <Grid sx={{display:"flex"}}spacing={2}>
            {/* General Information */}
            <Grid item xs={4}>
              <Card
                sx={{
                  padding: 2,
                  bgcolor: "#032643",
                  color: "white",
                  width: "100%",
                  maxWidth: "1200px",
                  height: "300px",
                  margin: "0 auto",
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: "bold", marginBottom:"5px" }}>
                  General Information
                </Typography>
                {/* General Information  */}
                <Grid container spacing={2}>
                  {generalInfo?.map((item, index) => (
                    <Grid item xs={6} key={index}>
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: "bold", color: "#D3F4FE" }}
                      >
                        {Object.keys(item)[0]}
                      </Typography>
                      <Typography>{Object.values(item)[0]}</Typography>
                    </Grid>
                  ))}
                </Grid>
              </Card>
            </Grid>

            {/* KPI*/}
            <Grid item xs={4}>
              <Card
                sx={{
                  padding: 2,
                  bgcolor: "#032643",
                  color: "white",
                  width: "100%",
                  maxWidth: "1200px",
                  height: "300px",
                  margin: "0 auto",
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: "bold",marginBottom:"5px" }}>
                  Key Performance
                </Typography>
                {/* General Information  */}
                <Grid container spacing={2}>
                  {KPIinfo?.map((item, index) => (
                    <Grid item xs={6} key={index}>
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: "bold", color: "#D3F4FE" }}
                      >
                        {Object.keys(item)[0]}
                      </Typography>

                      {/* Avg Employee Satisfaction */}
                      {Object.keys(item)[0] ===
                      "Avg Employee Satisfaction Score" ? (
                        <Box>
                          <RatingMUI value={Object.values(item)[0]} />
                        </Box>
                      ) : Object.keys(item)[0] ===
                        "Overall Condition Summary" ? (
                        <Box sx={{ display: "flex", gap: 5 }}>
                          {item[Object.keys(item)[0]]?.map(
                            (condition, conditionIndex) => (
                              <Box
                                key={conditionIndex}
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <CircularProgressMUI
                                  unit={"%"}
                                  value={condition.value}
                                />
                                <Typography variant="caption" component="div">
                                  {condition.desc}
                                </Typography>
                              </Box>
                            )
                          )}
                        </Box>
                      ) : (
                        <Box sx={{ display: "flex", gap: 5 }}>
                          {item[Object.keys(item)[0]]?.map(
                            (condition, conditionIndex) => (
                              <Box
                                key={conditionIndex}
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <CircularProgressMUI
                                  unit={""} //1: percentage, 2: point
                                  value={condition.value}
                                />
                                <Typography variant="caption" component="div">
                                  {condition.desc}
                                </Typography>
                              </Box>
                            )
                          )}
                        </Box>
                      )}
                    </Grid>
                  ))}
                </Grid>
              </Card>
            </Grid>

            {/* Building*/}
            <Grid item xs={4}>
              <Card
                sx={{
                  padding: 2,
                  bgcolor: "#032643",
                  color: "white",
                  width: "100%",
                  maxWidth: "1200px",
                  height: "300px",
                  margin: "0 auto",
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: "bold",marginBottom:"5px" }}>
                  My Building
                </Typography>
                <div style={{ width: "100%", height: "70%",}}>
                  <img
                    className="object-cover w-100 h-100"
                    src="/images/building-map.png"
                    alt="social-employee"
                  />
                </div>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </CardContent>
      <CardActions disableSpacing></CardActions>
    </Box>
  );
}
